export const education = [
    {
        'degree': 'Master of Science',
        'abbreviation': 'M.Sc.',
        'major': 'Computer Science (in progress)',
        'minor': 'Security and Cloud Computing',
        'school': 'Aalto University',
        'time': 'September 2022 - July 2025',
        'courses': [
            'Microservice Architectures and Serverless Computing', 
            'Information Security', 
            'Cryptography', 
            'Declarative Programming', 
            'Full Stack Web Development', 
            'WWW Applications', 
            'Semantic Web',
        ],
    },
    {
        'degree': 'Bachelor of Science',
        'abbreviation': 'B.Sc.',
        'major': 'Data Science',
        'minor': 'Computational Engineering',
        'school': 'Aalto University',
        'time': 'September 2019 - July 2022',
        'courses': [
            'Databases', 
            'Machine Learning', 
            'Artificial Intelligence', 
            'Statistical Inference (R)', 
            'Data Structures and Algorithms', 
            'Principle of Algorithmic Techniques', 
            'Programming Courses (Scala, Python, C, and SQL)', 
            'Theory of Computation',
        ],
    }
]